<template>
  <div class="package-dates">
    <h2 class="content-panel__title">Your Important Dates</h2>

    <div class="package-date">
      <span class="title">Utilities start date</span>
      <time :datetime="tenancyStartDate" data-testid="tenancy-start-date">
        {{ tenancyStartDate | FormatDate }}
      </time>
    </div>
    <div class="package-date">
      <span class="title">Utilities end date</span>
      <time :datetime="tenancyEndDate" data-testid="tenancy-end-date">
        {{ tenancyEndDate | FormatDate }}
      </time>
    </div>
    <div class="package-date">
      <span class="title">First payment date</span>
      <time :datetime="firstPaymentDate" data-testid="first-payment-date">
        {{ firstPaymentDate | FormatDate }}
      </time>
    </div>
    <div class="package-date" v-if="broadbandInstallationDate">
      <span class="title">Preferred broadband install</span>
      <time
        :datetime="broadbandInstallationDate"
        data-testid="broadband-start-date"
      >
        {{ broadbandInstallationDate | FormatDate }}
      </time>
    </div>
  </div>
</template>

<script>
import FormatDate from "@/filters/FormatDate";

export default {
  name: "PackageSchedule",
  props: {
    tenancyStartDate: {
      type: String,
      required: true,
    },
    tenancyEndDate: {
      type: String,
      required: true,
    },
    firstPaymentDate: {
      type: String,
      required: true,
    },
    broadbandInstallationDate: {
      type: String,
      required: false,
    },
  },
  filters: {
    FormatDate,
  },
};
</script>

<style lang="scss" scoped>
.package-dates {
  display: flex;
  flex-direction: column;
  background: $white;

  .package-date {
    font-size: 16px;

    * {
      display: block;
    }

    .title {
      font-weight: $font-bold;
    }

    &:not(:last-of-type) {
      margin-bottom: $spacing-small;
    }
  }
}
</style>
